const clientInfoTabs = {
  CHECKIN_ACTIVITY: 'CHECKIN_ACTIVITY',
  BILLING_DETAILS: 'BILLING_DETAILS',
  FOOD_LOG: 'FOOD_LOG',
  CLIENT_INFO: 'CLIENT_INFO',
  NOTES: 'NOTES',
  WORKOUT_CALENDAR: 'WORKOUT_CALENDAR',
  WORKOUT_HISTORY: 'WORKOUT_HISTORY',
  NUTRITIONAL_HISTORY: 'NUTRITIONAL_HISTORY',
  RECIPE_PREFERENCES: 'RECIPE_PREFERENCES',
  CLIENT_SETTINGS: 'CLIENT_SETTINGS',
  CLIENT_HISTORY: 'CLIENT_HISTORY',
};

export default clientInfoTabs;
